import { type BlocksFactory, INLINE_BLOCK_BUNDLE } from '@commons/pagebuilder/blocks';

import AlgoliaSearchBlock from './AlgoliaSearch';
import CardBlock from './Card';
import MemberLayoutBlock from './Members';

/**
 * Enum of all available plugin block bundles for AiiA.
 *
 * Makes it easier to read and edit the bundles.
 */

export enum AIIA_PLUGIN_BLOCK_BUNDLE {
  AlgoliaSearch = 'pure_search_algolia_search_block',
  MemberLayout = 'crisis24_member_metadata',
}

/**
 * Enum of all available field block bundles for AiiA.
 *
 * Makes it easier to read and edit the bundles.
 */

export enum AIIA_FIELD_BLOCK_BUNDLE {}

/**
 * Factory of all available blocks for AiiA.
 */

export const aiiaBlocks: BlocksFactory = {
  [INLINE_BLOCK_BUNDLE.Card]: CardBlock,

  // Plugin blocks.
  [AIIA_PLUGIN_BLOCK_BUNDLE.AlgoliaSearch]: AlgoliaSearchBlock,
  [AIIA_PLUGIN_BLOCK_BUNDLE.MemberLayout]: MemberLayoutBlock,
};
